/* eslint-disable no-case-declarations */
import React, { createContext } from 'react';
import LoadingSpinner from '../LoadingSpinner';
import ErrorBoundary from '../ErrorBoundary';
import useOnlineBooking from './hooks/useOnlineBooking';
import Departures from './elements/Departures';
import Intro from './elements/Intro';
import TravelDetails from './elements/Forms/TravelDetails';
import Passengers from './elements/Forms/Passengers';

export const OnlineBookingContext = createContext(null);

const OnlineBooking = () => {
  const {
    waiting,
    departures,
    currentNav,
    nav,
    intro,
    id,
    forwardNav,
    backwardNav,
    form,
    initialTravelDetailsValues,
    travelDetailsValidationSchema,
    passengerValidationSchema,
    initialPassengerValues,
    selectedDeparture,
    setSelectedDeparture,
    disable,
    savedTravelDetails,
    savedPassengers,
  } = useOnlineBooking();

  if (waiting) {
    return <LoadingSpinner />;
  } else {
    let component;

    switch (currentNav.slug) {
      case 'departures':
        component = <Departures />;
        break;
      case 'travel-details':
        component = <TravelDetails savedTravelDetails={savedTravelDetails} />;
        break;
      case 'passengers':
        component = (
          <Passengers
            savedPassengers={savedPassengers}
            savedTravelDetails={savedTravelDetails}
          />
        );
        break;
      case 'billing':
        break;
      case 'confirmation':
        break;
      default:
        throw new Error(`Can't find nav state for '${currentNav.slug}'`);
    }

    return (
      <OnlineBookingContext.Provider
        value={{
          departures,
          intro,
          id,
          nav,
          forwardNav,
          backwardNav,
          form,
          initialTravelDetailsValues,
          travelDetailsValidationSchema,
          passengerValidationSchema,
          initialPassengerValues,
          selectedDeparture,
          setSelectedDeparture,
          disable,
        }}
      >
        <div
          className={`c-online-booking c-online-booking--${currentNav.slug}`}
        >
          <div className="c-online-booking__nav">
            <ul className="c-online-booking__nav__list">
              {nav.map((element, index) => (
                <li
                  className={`c-online-booking__nav__list__nav-element ${
                    currentNav.slug === element.slug
                      ? 'c-online-booking__nav__list__nav-element--active'
                      : ''
                  }`}
                  key={`nav-element__${element.slug}`}
                >
                  <div>
                    <div className="c-online-booking__nav__list__nav-element__number">
                      {index + 1}
                    </div>

                    <div className="c-online-booking__nav__list__nav-element__text">
                      {element.display}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <Intro
            intro={intro}
            id={id}
            currentNav={currentNav}
            selectedDeparture={selectedDeparture}
          />

          <ErrorBoundary>{component}</ErrorBoundary>
        </div>
      </OnlineBookingContext.Provider>
    );
  }
};

export default OnlineBooking;
